export const LISTING_STATUS_KEYS = {
  LISTED: 'LISTED',
  UNLISTED: 'UNLISTED',
};

export const LISTING_STATUS = [
  { id: LISTING_STATUS_KEYS.LISTED, displayValue: 'Listed' },
  { id: LISTING_STATUS_KEYS.UNLISTED, displayValue: 'Unlisted' },
];
